const searchAction = {
  SET_ACTIVE: '@searchReducer/SET_ACTIVE',
  SET_VALUE: '@searchReducer/SET_VALUE'
};

export default searchAction;
